module.exports = __webpack_public_path__ + "img/49.fc5bab86.png";